import apiClient from "../apiClient";

const resource = "Qualifications";

export default {
    getQualifications: params => apiClient.get(`${resource}/Qualifications?${params}`),

};
